// extracted by mini-css-extract-plugin
export var boldText = "_4l-4";
export var checkboxContainer = "_4l-6";
export var closeIcon = "_4l-i";
export var container = "_4l-0";
export var drawer = "_4l-8";
export var drawerContent = "_4l-9";
export var extraSmallText = "_4l-5";
export var fulfillmentGroupTable = "_4l-e";
export var largeText = "_4l-3";
export var loadingSpinnerContainer = "_4l-j";
export var mediumText = "_4l-2";
export var narrow = "_4l-f";
export var notificationLink = "_4l-l";
export var packageCheckIconContainer = "_4l-7";
export var slideoutHeaderActions = "_4l-g";
export var slideoutHeaderActionsShifted = "_4l-h";
export var slideoutHeaderContainer = "_4l-a";
export var slideoutModal = "_4l-c";
export var stickyHeaderWrapper = "_4l-b";
export var table = "_4l-k";
export var tableContainer = "_4l-d";
export var tertiaryText = "_4l-1";